import axios from "../../axios";
import * as Requests from "../../requests";
import { UpdateSchedulePayload } from "../../../../../types";

export const updateWorkingHoursScheduleNameApi = (
    token: string,
    scheduleId: string,
    payload: UpdateSchedulePayload
) => {
    return axios.put(
        Requests.WORKING_HOURS_SCHEDULE_API(scheduleId),
        { ...payload },
        {
            headers: { token },
            baseURL: process.env.PICKUP_ENDPOINTS,
        }
    );
};
